import { GraphQLError } from "graphql";
import React from "react";
import { CriteriaValueInput, Service } from "rsl-api-106/lib/types";

type AuthContextType = {
  user: Service | null;
  setUser: (user: Service | null) => void;
  loading: boolean;
  login: (
    username: string,
    password: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  loginAnyclientType: (
    username: string,
    password: string,
    callback: (service: Service | null, err?: GraphQLError) => void
  ) => void;
  partnerLogin: (
    username: string,
    password: string,
    callback: (err?: GraphQLError) => void
  ) => void;
  register: (
    username: string,
    password: string,
    passwordConfirm: string,
    civility: string,
    firstname: string,
    lastname: string,
    birthdate: Date,
    languageCode: string,
    streetName: string,
    postalLocality: string,
    addressComplementary1: string,
    addressComplementary2: string,
    zipCode: string,
    city: string,
    country: string,
    phone1: string,
    phone2: string,
    fax: string,
    mail: string,
    criterias: CriteriaValueInput[],
    callback: (service: Service | null, err?: GraphQLError) => void
  ) => void;
  update: (
    username: string,
    password: string | null,
    passwordConfirm: string | null,
    civility: string,
    firstname: string,
    lastname: string,
    birthdate: Date,
    languageCode: string,
    streetName: string,
    postalLocality: string,
    addressComplementary1: string,
    addressComplementary2: string,
    zipCode: string,
    city: string,
    country: string,
    phone1: string,
    phone2: string,
    mail: string,
    criterias: CriteriaValueInput[],
    callback: (err?: GraphQLError) => void
  ) => void;
  signout: (callback: (err?: GraphQLError) => void) => void;
  delete: (callback: (err?: GraphQLError) => void) => void;
  facebookRegister: (
    facebookID: string,
    firstName: string,
    lastName: string,
    birthdate: Date,
    email: string,
    callback: (response?: Service, err?: GraphQLError) => void
  ) => void;
  facebookLogin: (
    facebookID: string,
    callback: (response?: Service, err?: GraphQLError) => void
  ) => void;
};

export const AuthContext = React.createContext<AuthContextType>({
  user: null,
  setUser: () => {},
  loading: true,
  login: () => {},
  loginAnyclientType: () => {},
  partnerLogin: () => {},
  register: () => {},
  update: () => {},
  signout: () => {},
  delete: () => {},
  facebookRegister: () => {},
  facebookLogin: () => {},
});
